import * as withSideEffect from "react-side-effect";
export var reducePropsToState = function (propsList) { return propsList
    .map(function (prop) { return prop.src; }); };
export var handleStateChangeOnClient = function () { return ({}); };
export var createScripts = function (state) { return state; };
var mapStateOnServer = function (state) { return createScripts(state); };
export var Asset = withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer)(function () { return null; });
export default Asset;



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/asset.tsx
// module id = xVEJ
// module chunks = 2 3